import {Pipe, PipeTransform} from '@angular/core';
import {getDeepField} from "@app/utils/_msf";
import {ServerTranslateService} from "@services/server-translate.service";

@Pipe({
  name: 'getById',
  standalone: true
})
export class GetByIdPipe implements PipeTransform {

    constructor(private serverTranslateService: ServerTranslateService) {

    }
    transform(model: any[], id:any,  modelField = 'name', lang:string): unknown {

    for (let index = 0; index < model.length; index++) {
        if (model[index].id == id) {
            return this.serverTranslateService.translate(model[index], modelField);
        }
    }
    return getDeepField({}, modelField);
  }

}
